import { SelectField } from './SelectField';
import { createFormikField } from './utils/createFormikField';

export const FormikSelectField = createFormikField(SelectField);
